import React from "react";

import { Route, Switch, useRouteMatch } from "react-router-dom";

import RedirectWithLocation from "@src/config/routing/RedirectWithLocation";

import HouseholdAccounts from "./HouseholdsDrawer/HouseholdAccounts/HouseholdAccounts";
import HouseholdDocuments from "./HouseholdsDrawer/HouseholdDocuments/Documents";
import HouseholdProfile from "./HouseholdsDrawer/HouseholdProfile/HouseholdProfile";
import HouseholdsDrawer from "./HouseholdsDrawer/HouseholdsDrawer";

const HouseholdsDrawerRouter = (): JSX.Element => {
  const match = useRouteMatch();

  return (
    <HouseholdsDrawer>
      <Switch>
        <Route exact path={`${match.path}/Profile`}>
          <HouseholdProfile />
        </Route>
        <Route exact path={`${match.path}/Accounts`}>
          <HouseholdAccounts />
        </Route>
        <Route exact path={`${match.path}/Documents`}>
          <HouseholdDocuments />
        </Route>
        <Route path={`${match.path}/:invalidTab`}>
          <RedirectWithLocation pathname={`/Advisor/Clients`} />
        </Route>
      </Switch>
    </HouseholdsDrawer>
  );
};

export default HouseholdsDrawerRouter;
